import type { ViewId, ViewModelId } from 'balus-common';
import { Link } from 'react-router';
import { UserPagePathBuilder } from '@user/pages/UserPagePathBuilder';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWindowMaximize } from '@fortawesome/free-regular-svg-icons';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { useTranslation } from 'react-i18next';
import { classNames } from '@framework/utils';
import { HighlightText } from './HighlightText';

type Props = {
  viewId: ViewId;
  viewIsLocked: boolean;
  viewName: string;
  viewModelId: ViewModelId;
  searchKeyword?: string;
  isExternal?: boolean;
};

export const ViewItemTitle: React.FC<Props> = ({
  viewId,
  viewIsLocked,
  viewName,
  viewModelId,
  searchKeyword,
  isExternal = false,
}: Props) => {
  const { t } = useTranslation();
  return (
    <Link
      to={`${UserPagePathBuilder.viewModelPage(viewModelId)}?targetView=${viewId}`}
      className={classNames('flex min-w-0 items-center rounded-sm py-1 pr-1')}
      {...(isExternal && { target: '_blank', rel: 'noopener noreferrer' })}
    >
      <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
        <FontAwesomeIcon icon={faWindowMaximize} />
      </span>
      {viewIsLocked && (
        <span className="fa-layers fa-fw mr-1 shrink-0 text-brand">
          <FontAwesomeIcon icon={faLock} />
        </span>
      )}
      <HighlightText
        className="truncate"
        text={viewName || t('canvas.viewTitle.placeholder')}
        keyword={searchKeyword || ''}
      />
    </Link>
  );
};
